import { render, staticRenderFns } from "./ConfirmationOfCompletedWork.vue?vue&type=template&id=1a6f3008&scoped=true&"
import script from "./ConfirmationOfCompletedWork.vue?vue&type=script&lang=js&"
export * from "./ConfirmationOfCompletedWork.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationOfCompletedWork.vue?vue&type=style&index=0&id=1a6f3008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6f3008",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VContainer,VDataTable,VIcon,VRow,VSelect,VSimpleTable})
